export default "__VITE_ASSET__BQnWVbvh__"